import { ButtonProps } from '../Button/Button.types';
import { AngleInputProps } from '../AngleInput/AngleInput.types';
import { IconButtonProps } from '../IconButton';
import { AccordionProps } from '../Accordion';
import { TableListItemProps } from '../TableListItem';
import { TextButtonProps } from '../TextButton/TextButton.types';
import { InputProps } from '../Input/Input.types';
import { DropdownProps } from '../Dropdown';
import { AutoCompleteProps } from '../AutoComplete';
import { MultiSelectProps } from '../MultiSelect';
import { MultiSelectCheckboxProps } from '../MultiSelectCheckbox';
import { NumberInputProps } from '../NumberInput';
import { InputAreaProps } from '../InputArea';
import { RichTextInputAreaProps } from '../RichTextInputArea';
import { SearchProps } from '../Search';
import { TimeInputProps } from '../TimeInput';
import { ColorInputProps } from '../ColorInput';
import { HeaderProps as SidePanelHeaderProps } from '../SidePanel/components/Header';
import { SidePanelProps } from '../SidePanel';
import { ThumbnailProps } from '../Thumbnail/Thumbnail.types';
import { TableActionCellProps } from '../TableActionCell/TableActionCell.types';
import { PopoverMenuProps } from '../PopoverMenu';
import { DockProps } from '../Dock/Dock.types';
import { CloseButtonProps } from '../CloseButton/CloseButton.types';

export interface ProviderDefaultPropSupportedComponents {
  Button: ButtonProps;
  IconButton: IconButtonProps;
  Accordion: AccordionProps;
  TableListItem: TableListItemProps;
  TableActionCell: TableActionCellProps;
  TextButton: TextButtonProps;
  Input: InputProps;
  InputArea: InputAreaProps;
  RichTextInputArea: RichTextInputAreaProps;
  NumberInput: NumberInputProps;
  AngleInput: AngleInputProps;
  Dropdown: DropdownProps;
  AutoComplete: AutoCompleteProps;
  Search: SearchProps;
  TimeInput: TimeInputProps;
  ColorInput: ColorInputProps;
  MultiSelect: MultiSelectProps;
  MultiSelectCheckbox: MultiSelectCheckboxProps;
  ['SidePanel.Header']: SidePanelHeaderProps;
  SidePanel: SidePanelProps;
  Thumbnail: ThumbnailProps;
  PopoverMenu: PopoverMenuProps;
  Dock: DockProps;
  CloseButton: CloseButtonProps;
}

export type ProviderDefaultPropSupportedComponentName =
  keyof ProviderDefaultPropSupportedComponents;

export type WixDesignSystemDefaultProps = {
  [K in ProviderDefaultPropSupportedComponentName]?: Partial<
    ProviderDefaultPropSupportedComponents[K]
  >;
};
